import { ENVIRONMENT } from '../../../../environments/environment';

/** Base URL for public leaderboard API (ms-leaderboard; no trailing slash). */
export function leaderboardEventsApiBase(): string | null {
  const base = ENVIRONMENT.leaderboardEventsApiUrl?.trim();
  if (!base) {
    return null;
  }
  return base.replace(/\/$/, '');
}

/** `/commerce/:id/leaderboard/:boardId` under the events API prefix. */
export function leaderboardBoardBaseUrl(
  commerceId: number,
  leaderboardId: string,
): string | null {
  const api = leaderboardEventsApiBase();
  const lb = leaderboardId?.trim();
  if (!api || !lb || !Number.isFinite(commerceId) || commerceId <= 0) {
    return null;
  }
  return `${api}/commerce/${commerceId}/leaderboard/${encodeURIComponent(lb)}`;
}
